module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-2x3-1dce6f449d30a0e3c8233e8a45e418b7.jpg";